import AssetImg from "../AssetImg";
import { Container } from "./styles";

export default function Logos({ small = false, asSeenIn = true, vanityFair = true, newYorkTimes = false, newYorker = true, atlantic = true, theVerge = true, washingtonPost = true, wired = true }) {
  return (
    <Container
      className="logos-container"
      small={small}
    >
      {asSeenIn && <p className="as-seen-in">AS SEEN IN</p>}
      <div className="logos">
        {vanityFair && (
          <AssetImg
            src="vanity_fair_logo.png"
            alt="Vanity Fair logo"
          />
        )}
        {newYorkTimes && (
          <AssetImg
            src="The_New_York_Times.png"
            alt="New York Times logo"
          />
        )}
        {newYorker && (
          <AssetImg
            src="The_New_Yorker.png"
            alt="New Yorker logo"
          />
        )}
        {atlantic && (
          <AssetImg
            src="Atlantic-logo.png"
            alt="The Atlantic logo"
          />
        )}
        {theVerge && (
          <AssetImg
            src="verge-logo.png"
            alt="The Verge logo"
          />
        )}
        {washingtonPost && (
          <AssetImg
            src="The_Washington_Post.png"
            alt="Washington post logo"
          />
        )}
        {wired && (
          <AssetImg
            src="Wired_logo.png"
            alt="Wired logo"
          />
        )}
      </div>
      {asSeenIn && <p className="as-seen-in">AS SEEN IN</p>}
    </Container>
  );
}
